/** Keep digits only; strip a leading 91 country code so values stay 10 digits. */
export function toTenDigitPhone(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (digits.length >= 12 && digits.startsWith('91')) {
    return digits.slice(2, 12);
  }
  return digits.slice(0, 10);
}

export function getTenDigitPhoneError(value, { required = false } = {}) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return required ? 'Phone is required' : '';
  if (digits.length !== 10) return 'Enter a valid 10-digit phone number';
  return '';
}
